/* global G */
import { curry } from 'lib/util'

const descriptor = 'model::installationReport::transformer::toInstallationDate'
/**
 * To InstallationDate Transformer
 *
 * Returns the installation date withouth the time component
 *
 * @param {string} key key of the property
 * @returns {(function(...[*]): (*))|*}
 */
const fn = key => curry((obj, data) => {
  const _data = data

  try {
    const item = obj[G.CHILDREN][key]
    const { type } = item[G.PROPS]
    const value = obj[G.STATE]?.[G.DATA]?.value[key]

    // eslint-disable-next-line prefer-destructuring
    value && (_data[type][key] = value.split('T')[0])
  } catch (e) {
    console.error(descriptor, e)
  }

  return _data
})

export default fn
